import React, { useState } from 'react';
import ScoreReadout from './ScoreReadout';
import LinksDoctorNote from './LinksDoctorNote';

const EMPTY = { eye: null, verbal: null, motor: null, pupils: null };

const groups = [
  {
    key: 'eye',
    title: 'Abertura ocular',
    letter: 'O',
    options: [
      [4, 'Espontânea', 'Abre os olhos espontaneamente'],
      [3, 'Ao som / à fala', 'Abre os olhos ao estímulo sonoro'],
      [2, 'À pressão', 'Abre os olhos após estímulo de pressão'],
      [1, 'Ausente', 'Sem abertura ocular'],
      ['NT', 'Não testável', 'Edema periorbital ou trauma ocular'],
    ],
  },
  {
    key: 'verbal',
    title: 'Resposta verbal pré-verbal',
    letter: 'V',
    options: [
      [5, 'Interage adequadamente', 'Balbucia, arrulha, sorriso social, fixa e segue objetos'],
      [4, 'Choro consolável', 'Choro irritado, mas consolável'],
      [3, 'Choro persistente', 'Choro inconsolável ou gemido à pressão'],
      [2, 'Agitação inconsolável', 'Agitação ou inquietação sem resposta verbal adequada'],
      [1, 'Ausente', 'Sem resposta verbal'],
      ['NT', 'Não testável', 'Intubação, traqueostomia ou outro fator de interferência'],
    ],
  },
  {
    key: 'motor',
    title: 'Resposta motora',
    letter: 'M',
    options: [
      [6, 'Espontânea / obedece', 'Movimento espontâneo e adequado para a idade ou obedece'],
      [5, 'Localiza / retira ao toque', 'Localiza o estímulo ou retira ao toque'],
      [4, 'Flexão normal', 'Retirada à pressão'],
      [3, 'Flexão anormal', 'Padrão de decorticação'],
      [2, 'Extensão', 'Padrão de descerebração'],
      [1, 'Ausente', 'Sem resposta motora'],
      ['NT', 'Não testável', 'Bloqueio neuromuscular, sedação profunda ou limitação motora'],
    ],
  },
];

export default function PediatricCalculator() {
  const [selections, setSelections] = useState(EMPTY);
  const [severity, setSeverity] = useState(null);

  const choose = (key, value) => {
    setSelections((prev) => ({ ...prev, [key]: prev[key] === value ? null : value }));
  };

  return (
    <section className="pediatric-calculator" aria-labelledby="ped-calc-title">
      <div className="calculator-section__intro">
        <div>
          <span className="section-kicker">Calculadora pediátrica</span>
          <h2 id="ped-calc-title">Calcule e veja o resultado</h2>
        </div>
        <p>Descritores adaptados para crianças pré-verbais. As amplitudes permanecem O 1–4, V 1–5 e M 1–6.</p>
      </div>

      <div className="calc">
        <div className="calc__main">
          {groups.map((group) => (
            <fieldset className="grp" key={group.key} data-cat={group.key}>
              <legend className="grp__lg">
                <span className="grp__n mono">{group.letter}</span>
                <span>{group.title}</span>
                <span className="grp__r mono">{group.key === 'eye' ? '1–4' : group.key === 'verbal' ? '1–5' : '1–6'}</span>
              </legend>
              <div className="keys" data-n={group.options.filter(([v]) => v !== 'NT').length}>
                {group.options.map(([value, label, desc]) => (
                  <button
                    key={String(value)}
                    type="button"
                    className={`key${value === 'NT' ? ' key--nt' : ''}`}
                    aria-pressed={selections[group.key] === value}
                    onClick={() => choose(group.key, value)}
                  >
                    <span className="key__lb">{label}</span>
                    <span className="key__pt mono">{value}</span>
                    <span className="key__ds">{desc}</span>
                  </button>
                ))}
              </div>
            </fieldset>
          ))}

          <button type="button" className="btn" onClick={() => setSelections(EMPTY)}>Limpar avaliação</button>
        </div>

        <ScoreReadout selections={selections} onSeverityChange={setSeverity} />
      </div>
      <p className="text-gray-500 text-xs mt-3">Resultado atual: {severity ? `faixa ${severity}` : 'preencha O, V e M'}. Se houver componente NT, não some o total.</p>
      <LinksDoctorNote show={Boolean(severity)} source="pediatrica" />
    </section>
  );
}
